import React from 'react'
import HRBackground from '../assets/img/bih-header-uskrs-2026.png'

const heroStyle = {
    background: `url(${HRBackground})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '30vh',
    minHeight: '700px',
    maxHeight: '700px',
}

const HeroContent = () => {
    return (
        <div className="content-hero content-hero-bih" style={heroStyle}></div>
    )
}

export default HeroContent